import axios from "axios";

// Prefer runtime origin (the domain the user is actually visiting) so the app works
// identically on preview, production, and any custom domain — without rebuilding the
// frontend with a different REACT_APP_BACKEND_URL.
const BACKEND_URL =
  (typeof window !== "undefined" && window.location.origin) ||
  process.env.REACT_APP_BACKEND_URL ||
  "";
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

// Auto-redirect to login on 401 (except for /auth/me which is the auth probe)
client.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/me") && window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const api = {
  // Auth
  getAuthUrl: () => client.get("/auth/facebook/login").then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
  testLogin: (data) => client.post("/auth/test-login", data).then((r) => r.data),
  // Accounts/Connections
  listPages: () => client.get("/accounts/pages").then((r) => r.data),
  listConnections: () => client.get("/connections").then((r) => r.data),
  createConnection: (data) => client.post("/connections", data).then((r) => r.data),
  testSeedConnection: (data) => client.post("/connections/test-seed", data).then((r) => r.data),
  toggleConnection: (id, enabled) => client.patch(`/connections/${id}`, { enabled }).then((r) => r.data),
  deleteConnection: (id) => client.delete(`/connections/${id}`).then((r) => r.data),
  resubscribeConnection: (id) => client.post(`/connections/${id}/resubscribe`).then((r) => r.data),
  // Keywords
  listKeywords: (connId) =>
    client.get("/keywords", { params: connId ? { connection_id: connId } : {} }).then((r) => r.data),
  createKeyword: (data) => client.post("/keywords", data).then((r) => r.data),
  updateKeyword: (id, data) => client.put(`/keywords/${id}`, data).then((r) => r.data),
  deleteKeyword: (id) => client.delete(`/keywords/${id}`).then((r) => r.data),
  // Activity + Stats
  listActivity: (limit = 100) => client.get(`/activity?limit=${limit}`).then((r) => r.data),
  clearActivity: () => client.delete("/activity").then((r) => r.data),
  getStats: () => client.get("/stats").then((r) => r.data),
  // Posts (per-connection IG media + backfill)
  listMedia: (connId, limit = 25) =>
    client.get(`/connections/${connId}/media`, { params: { limit } }).then((r) => r.data),
  backfillMedia: (connId, mediaId, { dryRun = true, onlyDm = false, limit = 250 } = {}) =>
    client
      .post(`/connections/${connId}/media/${mediaId}/backfill`, { dry_run: dryRun, only_dm: onlyDm, limit })
      .then((r) => r.data),
  // Account
  deleteMyAccount: () => client.delete("/auth/me").then((r) => r.data),
};

export const webhookUrl = () => `${API}/webhook`;
export const dataDeletionUrl = () => `${API}/data-deletion`;
